import React, { useState } from "react";
import { createSecret } from "../../Redux/actions/vault";

function CreateVault(props) {
    let state = {
        name: "",
        type: "0",
        text:"",
        integer:"",
        username: "",
        password: "",
        boolean : "true", 
        errors:{
            name:"",
            type:"",
            text:"",
            integer:"",
            username:"",
            password:""
        }       
    }

    let [obj, setObj] = useState(state);
    const [loading, setLoading] = useState(false);
    const [enableSubmit, setEnableSubmit] = useState(true);
    const [errMsg,setErrMsg] = useState(false)
 
    const handleChange = (e) => {  
        let {name,value} = e.target        
        obj = { ...obj, [e.target.name]: e.target.value }
        let { errors } = obj
        switch(name){
          case 'name':
            errors.name = value.length === 0 ? 'Name should not be empty': '';
            break;
          case 'type':              
            errors.type =  value.length <= 1 ?  'Type should not be empty': '';
            break;
          case 'text':
            errors.text = value.length === 0 ? 'Value should not be empty':'';
            break;
          case 'integer':                        
            errors.integer = value.length === 0 && !value.match(/[0-9]+(\.[0-9]+)?$/)? 'Integer should not be empty & should be valid':'' ;
            break;
          case "username":
            errors.username = value &&  value.length === 0 ?
            " Username should not be empty":""
            break;
          case 'password':
            errors.password = value && value.length === 0 ?
            " Password should not be empty":""
            break;
            default:
        }
        setObj({ ...obj , errors});
        setEnableSubmit(false);
    }

    const validation = (errors)=>{        
        let valid = true;
        Object.values(errors).forEach(
          (val) => val.length > 0 && (valid = false)
        );        
        return valid;
      }

    const handleSubmit= async (e) => {        
        e.preventDefault();
        let { errors ,name , type ,text ,integer ,username ,password ,boolean} = obj
        let condition=validation(errors) && name.length>0 && type.length>1
        if( condition && text.length>0 && boolean.length>0|| condition && integer.length>0 || condition && username.length>0 && password.length>0 || condition && type==="boolean" ){
           setLoading(true);               
                let payload = {
                    name,
                    type,
                    data : {}
                }
                if(type === "boolean") payload["data"]["value"] = obj.boolean;
                if(type === "integer") payload["data"]["value"] = obj.integer;
                if(type === "text") payload["data"]["value"] = obj.text;
                if(type === "credentials") {
                    payload["data"]["username"] = obj.username;
                    payload["data"]["password"] = obj.password
                } 
                let status=await createSecret(payload);
                if(status == 200){
                    setLoading(false);
                    props.secretSuccess();
                }else{
                    setLoading(false)
                }
        }
        else{
            setErrMsg(true)
        }
    }

    const renderValues = () => { 
         if(obj.type === 'text'){
            return(
            <div className="form-group">
                <label htmlFor="exampleInputName">Value</label>
                <input type="value" className="form-control" name="text" onChange={handleChange} value={obj.text ? obj.text : ""}  required></input>
                {obj.errors.text.length > 0 && 
                <span className='error'>{obj.errors.text}</span>}
            </div>
            )
        }
        else if(obj.type === 'boolean'){
            return(
                <div className="form-group">
                <label htmlFor="exampleInputName">Value</label><br></br>
                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="boolean" value="true" id="inlineRadio1" onChange={handleChange} checked={obj.boolean === "true" ? true : false}/>
                    <label className="form-check-label" htmlFor="inlineRadio1">True</label>
                </div>
                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="boolean" value="false" id="inlineRadio2" onChange={handleChange} checked={obj.boolean === "false" ? true : false}/>
                    <label className="form-check-label" htmlFor="inlineRadio2">False</label>
                </div>
                </div>
            )
        }
        else if(obj.type === 'integer'){
            return(
             <div className="form-group">
                <label htmlFor="exampleInputName">Value</label>
                <input type="number" className="form-control" name="integer" onChange={handleChange} value={obj.integer}  required></input>
                {obj.errors.integer.length > 0 && 
                <span className='error'>{obj.errors.integer}</span>}
            </div>
            )
        }
       
        else if(obj.type === 'credentials'){
            return(
             <div>
                <div className="form-group">
                    <label htmlFor="exampleInputName">Username</label>
                    <input type="text" className="form-control" name="username" onChange={handleChange} value={obj.username ? obj.username : ""}  required></input>
                    {obj.errors.username.length > 0 && 
                    <span className='error'>{obj.errors.username}</span>}
                </div>
                <div className="form-group">
                    <label htmlFor="exampleInputName"> Password</label>
                    <input type="password" className="form-control" name="password" onChange={handleChange} value={obj.password ? obj.password : ""}  required></input>
                    {obj.errors.password.length > 0 && 
                    <span className='error'>{obj.errors.password}</span>}
                </div>
            </div>
            )
        }
        else{
            return null
        }
    }
    
    return(
        <div>
                { errMsg ? <div className="alert alert-danger" role="alert">
                 Please enter all the fields</div> :""
                }
            <div className="form-group">
                <label htmlFor="exampleInputName"> Name</label>
                <input type="text" className="form-control" name="name" onChange={handleChange} value={obj.name} required></input>
                {obj.errors.name.length > 0 && 
                <span className='error'>{obj.errors.name}</span>}
            </div>
            <div className="form-group">
                <label htmlFor="exampleFormControlSelect1">Type</label>
                <select className="form-control" name="type" id="exampleFormControlSelect1" value={obj.type} onChange={handleChange} required>
                    <option value="0" checked >Choose Type</option>
                    <option value="text">Text</option>
                    <option value="boolean">Boolean</option>
                    <option value="integer">Integer</option>
                    <option value="credentials">Credentials</option>
                </select>
                {obj.errors.type.length > 0 && 
                <span className='error'>{obj.errors.type}</span>}
            </div>
            {renderValues()}
            <div className="text">
                <button  className="button"
                    onClick={()=>props.toggle()}>
                    Cancel
                </button>
                <button className="btn" onClick={handleSubmit} disabled={enableSubmit}>
                    {loading ? <i style={{ color: "#ffffff" }}
                                className="fas fa-circle-notch fa-spin"
                                ></i> : "Add" }
                </button>
            </div>
    </div>
    )
}
export default CreateVault;